// removed by extract-text-webpack-plugin
module.exports = {"Loading":"GameMenu__Loading__1iBQL","GameMenu":"GameMenu__GameMenu__Sj5Wz","GameMenuType":"GameMenu__GameMenuType__17ABr","Title":"GameMenu__Title__OgrxG","GameTypeBtn":"GameMenu__GameTypeBtn__xTQ_N","ResetBtn":"GameMenu__ResetBtn__DwLEF","Blue":"GameMenu__Blue__3zJ5d","Pink":"GameMenu__Pink__2gRSU"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/GameMenu/GameMenu.css
// module id = 386
// module chunks = 0